import { useState } from 'react'

import { CommonButton } from 'components/Button'
import SuccessModal from 'components/Modal/SuccessModal'
import { ButtonVariants } from 'components/Button/CommonButton'

interface RequestAccessButtonProps {
  homeName: string
  requestAccessHandler: () => Promise<void>
  variant?: ButtonVariants
}

function RequestAccessButton({
  homeName,
  requestAccessHandler,
  variant = 'secondary',
}: RequestAccessButtonProps) {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)

  const handleClick = () => {
    requestAccessHandler().then(() => {
      setIsConfirmModalOpen(true)
    })
  }

  /**
   * @todo add localization
   */

  return (
    <>
      <CommonButton variant={variant} onClick={handleClick}>
        Request Access
      </CommonButton>

      {isConfirmModalOpen && (
        <>
          <SuccessModal
            isOpen
            confirmBtnTitle="Close"
            title="Request Access"
            onConfirm={() => setIsConfirmModalOpen(false)}
          >
            A home access request has been sent to every administrator of &quot;
            {homeName}&quot;.
          </SuccessModal>
        </>
      )}
    </>
  )
}

export default RequestAccessButton
